<template>
  <h2 class="text-center text-title-sm font-black uppercase leading-9 text-white md:text-[62px] md:leading-[55.8px] [&>em]:not-italic [&>em]:text-purple [&>span]:text-primary-orange">
    <slot />
  </h2>
</template>
